import { Translate } from "next-translate";
import * as zod from "zod";

export const FIRESTORE_COLLECTION_NAME_QUESTION = "questions";

export interface Question {
  createdUnixTime: number;
  id: string;
  projectId: string;
  questionContent: string;
  requestedUserId: string | null;
  status: QuestionStatusEnum;
  topicId: string;
  topicName: string;
  topicSlug: string;
  updatedUnixTime: number;
}

export enum QuestionStatusEnum {
  active = "active",
  inactive = "inactive",
}

export const QUESTION_SCHEMA = (t: Translate) =>
  zod.object({
    questionContent: zod
      .string()
      .nonempty({
        message: t("form:validation.empty-input", {
          name: t("frontPage:question.post.content.label.question"),
        }),
      })
      .min(10, {
        message: t("form:validation.min-max", { max: 80, min: 10 }),
      })
      .max(80, {
        message: t("form:validation.min-max", { max: 80, min: 10 }),
      }),
    questionerEmail: zod.string().email({
      message: t("form:validation.invalid", {
        name: t("frontPage:question.post.content.label.mail"),
      }),
    }),
  });

export const QUESTION_MAIL_SCHEMA = (t: Translate) =>
  zod.object({
    content: zod.string().min(1, {
      message: t("form:validation.empty-input", {
        name: "メール本文",
      }),
    }),
    title: zod.string().min(1, {
      message: t("form:validation.empty-input", {
        name: "メールタイトル",
      }),
    }),
  });
